// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-modal-message[data-v-35f18d66]{font-weight:700}", "",{"version":3,"sources":["webpack://./resources/js/Components/Customers/Invoices/UpdateAccountingProductGroupModal.vue"],"names":[],"mappings":"AACA,qCACI,eAAA","sourcesContent":["\n.text-modal-message {\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
